import { isDev, sentryDsn, sentryEnvironment, release } from './configConstants';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

if (!isDev) {
  Sentry.init({
    dsn: sentryDsn,
    release,
    environment: sentryEnvironment,
    integrations: [new Integrations.BrowserTracing()],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.0
  });
}

const setUserContext = ({ userId }: { userId: number }) => {
  if (isDev) return;

  Sentry.configureScope(function(scope) {
    scope.setUser({ id: userId.toString() });
  });
};

export default {
  setUserContext
};
